export const getFirstScreenSelector = (store) => store.navigation.steps[0]?.step;
export const getCurrentScreenSelector = (store) => store.navigation.currentAdditionalScreen;
export const getSkippedScreensSelector = (store) => store.navigation.skippedSteps;
export const getMandatoryScreenSelector = (store) => store.navigation.steps.find((item) => item.step === store.navigation.currentAdditionalScreen)?.mandatory;
export const checkAvailabilityOfFeature = (store, featureKey) => {
    return store.navigation.profileTabs.find(el => el.key === featureKey) ? true : false;
};
